import React from 'react'
import ClassNames from 'classnames'
import { DatePickerInputStyle } from './styled'
import { Image } from '../../components'
import { ICONS } from '../../themes'

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export class DatePickerInput extends React.PureComponent {
  render() {
    const { label, className, disabled, id, showTimeInput } = this.props

    return (
      <DatePickerInputStyle
        className={ClassNames(
          'date-picker-wrapper',
          { 'is-disabled': disabled },
          { 'is-inline-datepicker': showTimeInput },
          className
        )}
      >
        {label && (
          <label className="label" htmlFor={id}>
            {label}
          </label>
        )}
        <div className="input-wrapper">
          <DatePicker
            {...this.props}
            className="date-picker-custom"
            id={id}
            popperPlacement="bottom-start"
            //  แต่ละ input  format ไม่เหมือนกัน
            // dateFormat="MMMM d, yyyy "
          />
          <Image
            src={ICONS['icon-calendar.svg']}
            alt="icon-calendar"
            className="calendar"
          />
        </div>
      </DatePickerInputStyle>
    )
  }
}
